<template>
	<div class="page">
		<div class="page-wrapper" ref="pageIndex">
			<div class="top-banner">
				<el-row>
					<el-col :span="18">
						<div class="logo">
							<img src="../assets/images/main/new/logo.png">
						</div>
					</el-col>
					<el-col :span="6">
						<div class="title">
							<img src="../assets/images/main/new/title.png">
						</div>
					</el-col>
				</el-row>
			</div>

			<div style="background-color:#5baaeb">
				<el-menu :default-active="activeIndex" style="list-style:none;display:inline-block;"
					class="el-menu-demo menu_nav" mode="horizontal" :router="true" @select="handleSelect"
					text-color="#ffffff" background-color="#5baaeb" :active-text-color="meun_active_color">
					<el-menu-item index="/main/index">首页</el-menu-item>
					<el-submenu index="2">
						<template slot="title">知识产权服务</template>
						<!--<el-menu-item index="/main/zscqzhfw/flfgzc">法律法规政策</el-menu-item>-->
						<el-menu-item index="/main/zscqzhfw/fwlmjj">知识产权服务联盟</el-menu-item>
						<el-menu-item index="/main/zscqzhfw/zyrzfw">质押融资服务</el-menu-item>
<!--						<el-menu-item index="/main/zscqzhfw/zscqcs">知识产权超市</el-menu-item>-->
						<el-menu-item index="/main/zscqzhfw/zscqzyzh">知识产权转移转化</el-menu-item>
<!--						<el-menu-item @click="openOutPage('http://123.233.113.66:8060/pubsearch')">-->
<!--							&lt;!&ndash;<el-link href="http://pss-system.cnipa.gov.cn/sipopublicsearch/portal/uiIndex.shtml"-->
<!--								target="_blank" :underline="false" style="color: #FFFFFF;">-->
<!--								国家知识产权局专利检索及分析-->
<!--							</el-link>&ndash;&gt;国家知识产权局新一代专利检索及分析-->
<!--						</el-menu-item>-->
		<!-- 				<el-menu-item @click="openNewPage('http://wcjs.sbj.cnipa.gov.cn/txnT01.do')">
							国家知识产权局商标查询
						</el-menu-item> -->
<!--						<el-menu-item @click="openOutPage('http://123.233.241.76:8090/')">-->
<!--							&lt;!&ndash;<el-link href="http://123.233.241.76:8090/" target="_blank" :underline="false"-->
<!--								style="color: #FFFFFF;">-->
<!--								山东省新旧动能转换专利库-->
<!--							</el-link>&ndash;&gt;山东省新旧动能转换专利库-->
<!--						</el-menu-item>-->
						<el-menu-item @click="openOutPage('http://kjy.weihai.cn/middleLogin')">
							<!--<el-link href="http://kjy.weihai.cn/middleLogin" target="_blank" :underline="false"
								style="color: #FFFFFF;">
								科技云专利检索分析
							</el-link>-->科技云专利检索分析
						</el-menu-item>
						<el-menu-item index="/main/zscqzhfw/whszl">威海市专利查询</el-menu-item>
						<el-menu-item index="/main/zscqzhfw/jlhyjtl">京鲁慧一键通览</el-menu-item>
					</el-submenu>
					<el-submenu index="3" :popper-append-to-body="true">
						<template slot="title">NQI服务</template>
						<el-menu-item index="/main/zltszhfw/jlfw">计量服务</el-menu-item>
						<el-menu-item index="/main/zltszhfw/bzfw">标准服务</el-menu-item>
						<!--<el-menu-item index="/main/zltszhfw/rzfw">认证认可</el-menu-item>-->
						<el-menu-item @click="openOutPage('/main/zltszhfw/rzfw')">认证认可</el-menu-item>
						<el-menu-item index="/main/zltszhfw/zlypp">质量及品牌</el-menu-item>
						<el-menu-item index="/main/zltszhfw/ylqxcx">医疗器械创新</el-menu-item>
            <el-menu-item index="/main/zltszhfw/zljcss">质量基础设施专业服务中心（平台）</el-menu-item>
						<!--<el-menu-item index="/main/zltszhfw/pxfw">培训服务</el-menu-item>-->
					</el-submenu>
					<el-submenu index="4" :popper-append-to-body="true">
						<template slot="title">小微驿站</template>
						<el-menu-item index="/main/xwqyczfw/xwqycx">小微企业查询</el-menu-item>
						<el-menu-item index="/main/xwqyczfw/djyl">党建引领</el-menu-item>
						<el-menu-item index="/main/xwqyczfw/wmcxyl">文明诚信引领</el-menu-item>
						<el-menu-item index="/main/xwqyczfw/rzfw">融资服务</el-menu-item>
						<el-menu-item index="/main/xwqyczfw/flwqdxalyfx">法律维权服务</el-menu-item>
						<el-menu-item index="/main/xwqyczfw/rcdj">人才对接</el-menu-item>
					</el-submenu>
					<el-submenu index="5" :popper-append-to-body="true">
						<template slot="title">检验检测服务</template>
						<el-menu-item index="/main/jyjcfw/cpzljc">产品质量检验</el-menu-item>
						<el-menu-item @click="openSsoPage('os_spjc')">
							<!--<el-link :underline="false" @click="openSsoPage('os_spjc')" target="_blank"
								style="color: #FFFFFF;">食品检验</el-link>-->
							食品检验
						</el-menu-item>
						<el-menu-item @click="openSsoPage('os_jls')">
							<!--<el-link :underline="false" @click="openSsoPage('os_jls')" target="_blank"
								style="color: #FFFFFF;">计量检定</el-link>-->
							计量检定
						</el-menu-item>
						<el-menu-item index="/main/jyjcfw/tzsbjc">特种设备检验</el-menu-item>
            <el-menu-item  @click="openOutPage('http://cx.cnca.cn/CertECloud/qts/qts/qtsPage?showMode=2')">检验检测报告编号查询</el-menu-item>
					</el-submenu>
					<el-menu-item index="/main/zltszhfw/pxfw">培训服务</el-menu-item>
					<el-menu-item index="/main/zscqzhfw/flfgzc">政策指南</el-menu-item>
					<el-menu-item @click="openNewPage('/main/zxzxForm')">
						在线咨询
					</el-menu-item>
          <el-submenu index="6" :popper-append-to-body="true">
            <template slot="title">数据提报</template>
            <el-menu-item @click="openNewPage('https://zhjg.weihai.cn/dataSubmit/tian_list?submitConfId=584')">
              医疗器械企业年度自查报告
            </el-menu-item>
            <el-menu-item @click="openNewPage('https://zhjg.weihai.cn/users/slpwy/priceManage')">
              阳光价格在线（物业收费）
            </el-menu-item>
          </el-submenu>

					<!--<el-menu-item>
						<el-link href="https://zhjg.weihai.cn/dataSubmit/tian_choose" target="_blank" :underline="false"
								 style="color: #FFFFFF;">
							数据提报
						</el-link>
					</el-menu-item>-->
					<el-menu-item @click="toOpenPage('/hkdt')">3D会客大厅</el-menu-item>
				</el-menu>
			</div>


			<keep-alive exclude="zyrzfwSb,zscqcsRecord,rzfw">
				<router-view :class="{ appWidth: isAppWidthActive }" />
			</keep-alive>
		</div>
	</div>
</template>
<script>
	import {
		getSsoDesInfo,
	} from "@/api/zlts/jlfw/jljgxx";
	import swal from "sweetalert";
	export default {
		name: 'Main',

		computed: {
			loginToken() {
				return this.$store.state.user.token
			},
			getIndex() {
				let mainIndex = this.$store.state.activeMenu.mainIndex;
				return mainIndex;
			}
		},
		data() {
			return {
				activeIndex: '1',
				meun_active_color: '#000000',
				isAppWidthActive: true,
				ssoOtherOsInfo: {},
			}
		},
		activated() {
			//  window.addEventListener('load', e =>this.beforeunloadHandler(e))

		},
		created() {
			// console.log("getIndex()="+getIndex());
		},
		watch: {
			'$route'(to, from) {

				this.appWidthActive(true);
			}
		},
		mounted() {
			//监听页面大小变化，设置基础字体大小
			/* 	this.handlePageResize();
				window.addEventListener("resize", this.handlePageResize); */
			this.$nextTick(() => {

				this.appWidthActive(true);

			})

		},
		beforeDestroy() {
			localStorage.clear();
			/* window.removeEventListener('resize', this.handlePageResize); */
		},
		methods: {

			toLogin() {
				this.$router.push({
					path: '/login'
				});
			},
			appWidthActive(bool) {
				let path = this.$route.path;
				if (path == '/main/index' || path == '/qygzs/index')
					this.isAppWidthActive = false;
				else
					this.isAppWidthActive = bool;
			},
			handleSelect(key, keyPath) {
				this.$store.commit('SET_MAININDEX', key);
			},
			openOutPage(url){
				// 2022-8-24 崔于此处修改
				if(url =='/main/zltszhfw/rzfw'){
					sessionStorage.removeItem("indexToRzfwCode");
				}
				this.utils.windowOpen(url);
			},
			openNewPage(url) {
				//----【】需要修改为recid
				//单点登录跳转
				let ssessionLoginUser = JSON.parse(localStorage.getItem('ssessionLoginUser'));
				if (this.utils.isLoginTimeout()) {
					this.utils.windowOpen(url);
				} else {
					if (ssessionLoginUser != null) {
						let ywFwjgRecid = ssessionLoginUser.user.ywFwjgRecid;
						this.$confirm(
								'登录请求已过期，您可以继续留在该页面，或者重新登录?',
								'系统提示', {
									confirmButtonText: '重新登录',
									cancelButtonText: '取消',
									type: 'warning'
								}
						).then(() => {
							this.logout(ywFwjgRecid)
						})
					} else {
						swal( "登录提示", "请先登录企业工作室，再进行数据提报，谢谢！","warning",{button: true}).then((value) => {
							// swal(`The returned value is: ${value}`);
							localStorage.clear();
							window.location.href = this.Config.sdtyrzfwLoginUrl;
						});
					}
				}

			},
			toOpenPage(topath) {
				this.$router.push({
					path: topath
				})
				this.$store.commit('SET_MAININDEX', topath);
			},
			handlePageResize() {
				//获取页面高度
				let bodyHeight = document.body.clientHeight;
				//长宽比按照1920*1080设置
				let bodyWidth = document.body.clientWidth;

				this.$refs.pageIndex.style.width = bodyWidth + 'px';
				this.$refs.pageIndex.style.hight = bodyHeight + 'px';

			},
			openSsoPage(syscode) {
				//----【】需要修改为recid
				//单点登录跳转
				let ssessionLoginUser = JSON.parse(localStorage.getItem('ssessionLoginUser'));
				if (this.utils.isLoginTimeout()) {
					this.ssoOtherOsInfo.syscode = syscode;
					this.ssoOtherOsInfo.uuid = ssessionLoginUser.ywFwjg.uuid;
					this.ssoOtherOsInfo.usertype = ssessionLoginUser.user.ftype;
					this.ssoOtherOsInfo.loginname = ssessionLoginUser.user.realName;
					this.ssoOtherOsInfo.entname = ssessionLoginUser.user.corname;
					this.ssoOtherOsInfo.entnumber = ssessionLoginUser.user.cornumber;
					this.ssoOtherOsInfo.ywFwjgRecid = ssessionLoginUser.user.ywFwjgRecid;
					getSsoDesInfo(this.ssoOtherOsInfo).then(response => {
						this.openNewPage(response.url + "?syscode=" + syscode + "&sign=" +
							response.sign);
						return true;
					});
				} else {
					if (ssessionLoginUser != null) {
						let ywFwjgRecid = ssessionLoginUser.user.ywFwjgRecid;
						this.$confirm(
							'登录请求已过期，您可以继续留在该页面，或者重新登录?',
							'系统提示', {
								confirmButtonText: '重新登录',
								cancelButtonText: '取消',
								type: 'warning'
							}
						).then(() => {
							this.logout(ywFwjgRecid)
						})
					} else {
						localStorage.clear();
						window.location.href = this.Config.sdtyrzfwLoginUrl;
					}
				}
			},
		}
	}
</script>
<style scoped>
	.page {
		overflow: auto;
		max-width: 100% !important;
	}

	.appWidth {
		max-width: 1300px;
		margin: 0 auto;
	}

	.top-banner {
		position: relative;
		width: 100%;
		height: 150px;
		background-image: url('../assets/images/main/new/bj-1.png');
		background-size: 100% 100%;
	}

	.logo {
		float: left;
	}

	.logo img {
		margin-top: 60px;
		margin-left: calc(100vw - 95vw);
		height: 32px;
		background-size: 100% 100%;

	}

	.title {
		float: left;
	}

	.title img {
		margin-top: 60px;
		height: 60px;
	}

	.menu_nav {
		/*padding-left: calc(100vw - 84vw);*/

	}

	/deep/ .el-menu {
		height: 40px;
		line-height: 40px;
	}

	/deep/ .el-menu--horizontal>.el-menu-item {
		float: left;
		height: 40px;
		line-height: 40px;
		margin: 0;
		border-bottom: 2px solid transparent;
		font-size: 16px;
		color: #909399;
	}

	/deep/ .el-menu--horizontal>.el-submenu .el-submenu__title {
		height: 40px;
		line-height: 40px;
		border-bottom: 2px solid transparent;
		color: #909399;
		font-size: 16px;
	}

	/deep/ .el-menu.el-menu--horizontal {
		border: 0;

	}
</style>
